import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Api} from "../api.service";
import {Observable} from "rxjs/Observable";
import * as moment from 'moment';
import {AuditLogResponse} from "../api/audits/api.models";

@Injectable()
export class AuditsResolver implements Resolve<any> {
    constructor(private api: Api) {}

    resolve(route: ActivatedRouteSnapshot): Observable<AuditLogResponse> {
        return this.api.audits().collection(
            1,
            100000,
            moment().set({'hour': 0, 'minute' : 0, 'second' : 0}).utc().format(),
            moment().set({'hour': 23, 'minute' : 59, 'second' : 59}).utc().format()
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/audits.resolver.ts